import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Icon, Link, Text, useTheme } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles, 'ExcessUsersBanner');

const ExcessUsersBanner = ({
    enabled,
    totalBillableUsers,
    totalUsersPurchased,
    href = '#/app/users',
    linkTarget,
    linkRel,
}) => {
    const { t } = useWeb5Context();
    const theme = useTheme();
    const classes = useStyles();

    const purchased = Number(totalUsersPurchased);
    const billable = Number(totalBillableUsers);
    const hasValidCounts = Number.isFinite(purchased) && purchased > 0 && Number.isFinite(billable);

    if (!enabled || !hasValidCounts) return null;

    const showLink = !!href;

    return (
        <div className={classes.root}>
            <Icon name="warningOutline" color={theme.colors.primary.black} />
            <Text type="body" medium className={classes.content}>
                <span className={classes.label}>
                    {t('label_banner_excess_users')
                        .replace('%@', billable)
                        .replace('%@', purchased)}
                </span>
                {showLink && (
                    <Link
                        type="body"
                        href={href}
                        target={linkTarget}
                        rel={linkRel}
                        variation="primary"
                        className={classes.link}
                    >
                        {t('action_banner_excess_users')}
                    </Link>
                )}
            </Text>
        </div>
    );
};

ExcessUsersBanner.propTypes = {
    enabled: PropTypes.bool.isRequired,
    totalBillableUsers: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalUsersPurchased: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    href: PropTypes.string,
    linkTarget: PropTypes.string,
    linkRel: PropTypes.string,
};

export default memo(ExcessUsersBanner);
